<template>
  <div>
    <div class="boxShell">
      <i class="iconfont icon-chenggong-icon topicon"></i>
      <p class="tip">绑定银行卡成功</p>
      <Button
        :text="draw"
        :type="danger"
        class="nextStep"
        :click='jumpTheThirdPartyAddress'
      ></Button>
    </div>
    <server-bank :productId="this.$route.query.productId"></server-bank>
  </div>
</template>
<script>
import Button from '@/components/Button.vue';
import ServerBank from '@/components/ServerBank.vue';
import { Toast } from 'vant';

export default {
  name: 'bankCardSuccess',
  data() {
    return {
      danger: 'danger',
      draw: '下一步',
    };
  },
  components: {
    Button,
    ServerBank
  },
  methods: {
    jumpTheThirdPartyAddress() {
      const { orderId, drawId = "", scene= 'LOAN', productId } = this.$route.query;
      this.$loading.show();
      this.$api.CommonForms.cardBindingSuccess({
        orderId: orderId || localStorage.getItem('orderId'),
        drawId,
        scene,
        productId,
      }).then((res) => {
        this.$loading.hide();
        if (res.success) {
          if (res.data) {
            window.location.href = res.data.url;
          }
        } else {
          Toast(res.returnMessage);
        }
      });
    },
  },
};
</script>
<style scoped>
.boxShell {
  padding-top: 103px;
}
.topicon {
  margin-top: 103px;
  color: #ff6538;
  font-size: 60px;
}
.tip {
  color: #1c2438;
  font-size: 17px;
  text-align: center;
}
.nextStep {
  margin-top: 100px;
  margin-bottom: 7px;
}
</style>
